import Icon from '../icon';
import BevSafeText from '../bev-safe-text';
import type { EditorialOverviewHighlight } from './editorial-overview.types';

const MAX_HIGHLIGHTS = 5;

type EditorialOverviewHighlightsProps = {
	highlights: EditorialOverviewHighlight[];
};

export default function EditorialOverviewHighlights({
	highlights,
}: EditorialOverviewHighlightsProps) {
	// Don't render if fewer than 4 highlights
	if (highlights.length < 4) {
		return null;
	}

	const shown = highlights.slice(0, MAX_HIGHLIGHTS);

	return (
		<div className="w-full max-w-[var(--wide-grid-container-width-lg,1260px)] mx-auto xl:max-w-none">
			{/* Desktop: centered flex row */}
			<div className="hidden lg:flex items-stretch justify-center gap-x-inline-m">
				{shown.map((highlight, index) => (
					<div
						key={index}
						className="flex flex-col items-center gap-y-stack-xs flex-1 max-w-[230px] xl:max-w-none"
					>
						<div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[rgba(203,196,188,0.2)]">
							<Icon icon={highlight.icon} className="text-[32px]" />
						</div>
						<span className="text-caption text-center text-text-heading">
							<BevSafeText>{highlight.label}</BevSafeText>
						</span>
					</div>
				))}
			</div>

			{/* Mobile: grid layout — 3 columns, auto rows */}
			<div className="lg:hidden md:px-150">
				<div className="grid grid-cols-3 gap-grid-gutter md:max-w-[345px] mx-auto">
					{shown.map((highlight, index) => (
						<div key={index} className="flex flex-col items-center gap-y-stack-xs">
							<div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[rgba(203,196,188,0.2)]">
								<Icon icon={highlight.icon} className="w-[32px] h-[32px]" />
							</div>
							<span className="text-caption text-center text-text-heading">
								<BevSafeText>{highlight.label}</BevSafeText>
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
